export default __webpack_public_path__ + "static/media/container_7486633.9e3ef96a.png";